import React from "react";
import Subscriber from "../../subscriber.class";
import Storage from "../../services/storage.service";
import Summary from "./summary";
import ModalLayout from "../../layouts/modal";
import EditDevicePopup from "../Plans/PhoneDeviceAddOn/EditDevicePopup";
export default class SummaryModal extends Subscriber {
  state = {
    summary_modal: false,
    deviceEditModal: false
  };

  componentDidMount() {
    this.subscriptions.push(
      Storage.get_obsrv("summary_modal").subscribe((data) => {
          this.setState({
            summary_modal: data
          });
      })
    );
    this.subscriptions.push(
      Storage.get_obsrv("showiPhoneEditModalOnMobile").subscribe((data) => {
          this.setState({
            summary_modal: false,
            deviceEditModal: data
          });
      })
    );
  }

  close = () => {
    Storage.clear("summary_modal");
  }

  render() {
    let content = "";
    if(this.state.summary_modal){
      content = <ModalLayout close={this.close} extras="vmo-modal-summary" ><Summary /></ModalLayout>;
    }
    if(this.state.deviceEditModal){
      content = <EditDevicePopup close={()=> this.setState({deviceEditModal: false})}/>
    }

    return content;
  }
}
